export const IFRAME_ID = 'tokenize-payment-instrument-iframe';
export const CONTAINER_ID = 'tokenize-payment-instrument-container';
